import { IChecklistItemsDatasource } from './../datasources/checklist_items_datasource';
import { ChecklistItem } from './../builders/checklist_item_builder';
import { IQuery, IQueryMediator } from 'core-ts-types';
import { IChecklistFilterStrategy } from '../strategies/checklist_filter_strategy';
import { ChecklistItemStatus } from '../../checklist/types/checklist_types';

export type AvailableFilters = Record<ChecklistItemStatus, ChecklistItem[]>;

export class ChecklistItemsByFilterQuery implements IQuery {
  private _result: {
    availableFilters: AvailableFilters;
    areAllItemsCompleted: boolean;
  };

  constructor(
    QueryMediator: IQueryMediator,
    private ngChecklistItemsDatasource: IChecklistItemsDatasource,
    private ngChecklistFilterStrategy: IChecklistFilterStrategy
  ) {
    QueryMediator.registerQuery(this, ngChecklistItemsDatasource);
  }

  run() {
    const availableFiltersArray = this.ngChecklistFilterStrategy.map((value, key) => {
      return {
        key: key!,
        items: value.filterChecklist(_.values<ChecklistItem>(this.ngChecklistItemsDatasource.read()))
      };
    });

    const keys = _.pluck<any, string>(availableFiltersArray, 'key');
    const groupedItems = _.pluck<any, ChecklistItem[]>(availableFiltersArray, 'items');
    const allItems = _.flatten(groupedItems);
    const availableFilters = _.zipObject<AvailableFilters>(keys, groupedItems);

    this._result = {
      availableFilters,
      areAllItemsCompleted: !_.isEmpty(allItems) && _.all(allItems, (item) => item.status === 'complete')
    };

    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-checklist').service('ngChecklistItemsByFilterQuery', ChecklistItemsByFilterQuery);



// WEBPACK FOOTER //
// ./app/lib/checklist/queries/checklist_items_by_filter_query.ts